import * as i0 from '@angular/core';
import { Injectable, inject, booleanAttribute, Input, ViewEncapsulation, ChangeDetectionStrategy, Component } from '@angular/core';
import { cn } from '@primeuix/utils';
import { BaseComponent } from 'primeng/basecomponent';
import { BaseStyle } from 'primeng/base';
const _c0 = ["*"];
const css = /*css*/`
.p-icon {
    display: inline-block;
    vertical-align: baseline;
    flex-shrink: 0;
}

.p-icon-spin {
    -webkit-animation: p-icon-spin 2s infinite linear;
    animation: p-icon-spin 2s infinite linear;
}

@-webkit-keyframes p-icon-spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

@keyframes p-icon-spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
`;
let BaseIconStyle = /*#__PURE__*/(() => {
  class BaseIconStyle extends BaseStyle {
    name = 'baseicon';
    css = css;
    static ɵfac = /* @__PURE__ */(() => {
      let ɵBaseIconStyle_BaseFactory;
      return function BaseIconStyle_Factory(__ngFactoryType__) {
        return (ɵBaseIconStyle_BaseFactory || (ɵBaseIconStyle_BaseFactory = i0.ɵɵgetInheritedFactory(BaseIconStyle)))(__ngFactoryType__ || BaseIconStyle);
      };
    })();
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BaseIconStyle,
      factory: BaseIconStyle.ɵfac,
      providedIn: 'root'
    });
  }
  return BaseIconStyle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 *
 * [Live Demo](https://www.primeng.org/)
 *
 * @module baseiconstyle
 *
 */
var BaseIconClasses = /*#__PURE__*/function (BaseIconClasses) {
  BaseIconClasses["root"] = "p-icon";
  return BaseIconClasses;
}(BaseIconClasses || {});
let BaseIcon = /*#__PURE__*/(() => {
  class BaseIcon extends BaseComponent {
    spin = false;
    _componentStyle = inject(BaseIconStyle);
    getClassNames() {
      return cn('p-icon', {
        'p-icon-spin': this.spin
      });
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵBaseIcon_BaseFactory;
      return function BaseIcon_Factory(__ngFactoryType__) {
        return (ɵBaseIcon_BaseFactory || (ɵBaseIcon_BaseFactory = i0.ɵɵgetInheritedFactory(BaseIcon)))(__ngFactoryType__ || BaseIcon);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BaseIcon,
      selectors: [["ng-component"]],
      hostAttrs: ["width", "14", "height", "14", "viewBox", "0 0 14 14", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"],
      hostVars: 2,
      hostBindings: function BaseIcon_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.getClassNames());
        }
      },
      inputs: {
        spin: [2, "spin", "spin", booleanAttribute]
      },
      features: [i0.ɵɵProvidersFeature([BaseIconStyle]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BaseIcon_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return BaseIcon;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BaseIcon, BaseIconClasses, BaseIconStyle };
